import { connect } from 'react-redux';
import actions from '../redux/actions/authorization';
import PermissionManagement from '../component/PermissionManagement';

const mapStateToProps = (state) => ({
  roles: state.authorization.roles,
  permissions: state.authorization.permissions,
  actions: state.authorization.actions,
  mapPermissions: state.admin.mapPermissions,

  listPermissions: state.authorization.permissions,
  totalPermissions: state.authorization.permissionsTotalCount,
  groupPermissions: state.authorization.groupPermissions,
});

const mapDispatchToProps = (dispatch) => ({
  getRoles: (callback) => {
    dispatch(actions.getRoles(callback));
  },
  addNewRole: (data, callbacks) => {
    dispatch(actions.postRole(data, callbacks));
  },
  getRoleInfoById: (roleId, callback) => {
    dispatch(actions.getRoleInfoById(roleId, callback));
  },
  postPermissionsControlsForRole: (data, callback) => {
    dispatch(actions.postPermissionsControlsForRole(data, callback));
  },

  addPermission: (data) => {
    dispatch(actions.addPermission(data));
  },
  getPermission: (pos, count) => {
    dispatch(actions.getPermission(pos, count));
  },
  putPermission: (params, callback) => {
    dispatch(actions.putPermission(params, callback));
  },
  deletePermission: (permissionId) => {
    dispatch(actions.deletePermission(permissionId));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PermissionManagement);
